<template>
  <div class="hatful-menu">
    <div class="hatful-content">
      <div class="hatful-left">
        <img src="../assets/logo.png" class="logo" />
        <p>HATFUL LIMITED</p>
      </div>
      <div class="hatful-menubox">
        <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">Download</div>
        <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">
          Privacy
        </div>
        <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
          Contact Us
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "projects" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;

        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.hatful-menu {
  width: 100%;

  .hatful-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 305px;
    background: #191A20;

    .hatful-left {
      display: flex;
      align-items: center;
      position: relative;

      .logo {
        margin-right: 16px;
        width: 33px;
        height: 33px;
      }

      p {
        font-size: 30px;
        font-family: Bebas;
        color: #FFFFFF;
      }
    }
  }

  .hatful-menubox {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: ArialMT;
    color: #FFFFFF;
    cursor: pointer;

    div {
      margin-right: 64px;
      font-size: 22px;
      font-family: PingFang SC, PingFang SC;
      color: rgba(255, 255, 255, 0.7);
    }
  }

  .select {
    font-weight: 600;
    color: #FFFFFF !important;
  }
}
</style>
